import { render } from "./ThroughNavigation.vue?vue&type=template&id=5b879556&scoped=true&ts=true"
import script from "./ThroughNavigation.vue?vue&type=script&lang=ts"
export * from "./ThroughNavigation.vue?vue&type=script&lang=ts"

import "./ThroughNavigation.vue?vue&type=style&index=0&id=5b879556&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b879556"]])

export default __exports__